import React, { Component } from "react";
import SpeechRecognition from "../../../../components/customModule/speechRecognition/SpeechRecognition";
import { generateTempWavFile, WavingLine } from "../../../../components/ui/SpeechTestBox";
import AppConfig from "../../../../config/AppConfig";
import Constants from "../../../../config/Constants";
import _ from "lodash";
import moment from "moment";
import UploadService from "../../../../services/screens/common/UploadService";
import localStorageFileHelper from "../../../../../utils/LocalStorageFileHelper";
import allSettled from "../../../../utils/allSettled";
import * as ErrorHelper from "../../../../utils/ErrorHelper";

function uploadHomeworkFileAsync(fileName) {
    return new Promise((resolve, reject) => {
        localStorageFileHelper.getFile(fileName).then(
            fileZ => {
                UploadService.uploadFile(
                    fileZ,
                    response => {
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    }
                );
            },
            error => {
                reject(error);
            }
        );
    });
}

function extractResult(r) {
    if (r.status === "fulfilled") {
        return r.value;
    }

    if (r.reason) {
        return { error: r.reason };
    }
    return { error: new Error('unknown error') };
}

class SpokenReadingResultView extends Component {
    lastResetDate = null;
    lastRecordDate = null;
    //在录音的时候app进入后台的情况下,我们会直接重置当前屏幕,在重置的过程中,语音识别的后续promise都直接丢弃不运行
    get isInResetting() {
        return this.lastResetDate && this.lastRecordDate && moment(this.lastResetDate).isAfter(this.lastRecordDate);
    }

    constructor(props) {
        super(props);

        this.localVars = {
            robotAudioRate: AppConfig.AUDIO_RATE_OF_ROBOT,
        };

        this.state = {
            volume: 0,
            showTopic: false,
        };
    }

    componentDidMount() {
        if (!this.props.readonly) {
            SpeechRecognition.initWithoutKey({
                lang: (this.props.data && this.props.data.language === "en") ? Constants.SPEECH_LANG.en : Constants.SPEECH_LANG.zh,
                enableSpeechRecognize: false,
                backgroundStopRecordCallback: () => {
                    //如果在整题录音时，切换到其他app(易度app退到后台)；此时应该取消录音，返回到题目页
                    if (this.backgroundStopRecordCallback) {
                        this.backgroundStopRecordCallback();
                    }
                },
            });
            /*
            SpeechRecognition.addEventListener("onStatChange", event => {
                //console.log(event);
            });
            SpeechRecognition.addEventListener("onVolumeChange", event => {
                if (event.Volume) {
                    this.setState({ volume: event.Volume });
                }
            });
            */
        }
    }

    componentWillUnmount() {
        if (!this.props.readonly) {
            SpeechRecognition.stopRecognize();
            SpeechRecognition.removeAllListeners();
            SpeechRecognition.destroy();
        }
    }

    backgroundStopRecordCallback = () => {};

    setSpeechRecognitionReferenceSyllables = Syllables => {
        if (this.props.readonly) {
            return;
        }
        if (Syllables) {
            SpeechRecognition.setReferenceSyllables(Syllables);
        }
    };

    setSpeechRecognitionReferenceMarkText = markText => {
        if (this.props.readonly) {
            return;
        }
        if (markText) {
            SpeechRecognition.setReferenceMarkText(markText);
        }
    };

    startRecord = ({ chars, fileName }, callback, endRecordingCallback) => {
        if (this.props.readonly) {
            return;
        }
        let wavFile = generateTempWavFile();
        SpeechRecognition.setWavFilePath(wavFile);
        SpeechRecognition.setReferenceText(chars);
        this.lastRecordDate = moment().toISOString();
        SpeechRecognition.startRecognize()
            .then(() => {
                if (this.isInResetting) {
                    return;
                }
                endRecordingCallback && endRecordingCallback();
                SpeechRecognition.getWavFilePath(wavFile, file => {
                    SpeechRecognition.recognizeFile(file)
                        .then(response => {
                            if (this.isInResetting) {
                                return;
                            }
                            console.log(response);

                            callback && callback(file, response);
                        })
                        .catch(e => {
                            if (this.isInResetting) {
                                return;
                            }
                            callback && callback(file, { error: e });
                            //this.displayError({ message: e.message });
                        });
                });
            })
            .catch(e => {
                if (this.isInResetting) {
                    return;
                }
                callback && callback({}, { error: e });
                //this.displayError({ message: e.message });
            });
    };

    startRecordAndUpload = ({ chars, fileName }, callback, endRecordingCallback) => {
        if (this.props.readonly) {
            return;
        }
        let wavFile = generateTempWavFile();
        SpeechRecognition.setWavFilePath(wavFile);
        SpeechRecognition.setReferenceText(chars);
        this.lastRecordDate = moment().toISOString();
        SpeechRecognition.startRecognize()
            .then(() => {
                if (this.isInResetting) {
                    return;
                }
                endRecordingCallback && endRecordingCallback();
                SpeechRecognition.getWavFilePath(wavFile, file => {
                    var promise1 = SpeechRecognition.recognizeFile(file);
                    var promise2 = uploadHomeworkFileAsync(file);
                    allSettled([promise1, promise2]).then(values => {
                        if (this.isInResetting) {
                            return;
                        }

                        var result1 = extractResult(values[0]);
                        var result2 = extractResult(values[1]);
                        if (result1.error) {
                            let error = result1.error;
                            let inVO = {
                                errorMessage: "SpokenReadingResultView:" + (error.message ? error.message : error.toString()),
                                errorPage: result2.virtualPath,
                                errorTrace: error.stack ? error.stack.toString() : "",
                            };
                            ErrorHelper.addError(inVO);
                        }
                        callback && callback(file, result1, result2);
                    });
                });
            })
            .catch(e => {
                if (this.isInResetting) {
                    return;
                }
                callback && callback({}, { error: e }, { error: e });
                //this.displayError({ message: e.message });
            });
    };

    startReIdentification = (file, chars, callback) => {
        if (this.props.readonly) {
            return;
        }
        SpeechRecognition.setReferenceText(chars);
        SpeechRecognition.recognizeFile(file)
            .then(response => {
                if (this.isInResetting) {
                    return;
                }
                console.log(response);
                callback && callback(response);
            })
            .catch(e => {
                if (this.isInResetting) {
                    return;
                }
                callback && callback({ error: e });
                //this.displayError({ message: e.message });
            });
    };

    endRecord = () => {
        if (this.props.readonly) {
            return;
        }
        SpeechRecognition.stopRecognize();
    };

    processUnitResult = userResult => {
        this.props.onReportResult && this.props.onReportResult(userResult);
    };

    continue = () => {
        this.props.onContinue && this.props.onContinue();
    };

    close = () => {
        this.props.onClose && this.props.onClose();
    };

    restart = () => {
        this.props.onRestart && this.props.onRestart();
    };

    displayError = error => {
        if (error && error.message) {
            this.props.onError && this.props.onError(error);
        }
    };

    // TopicModal = title => {
    //     const { data, settings } = this.props;
    //     const UnitView = UnitViews[data.unitType];
    //     return (
    //         <Modal
    //             visible={this.state.showTopic}
    //             onRequestClose={() => this.setState({ showTopic: false })}
    //             animationType="none"
    //         >
    //             <Header style={{ backgroundColor: "#fff" }}>
    //                 <Left style={{ flex: 1 }}>
    //                     <Button transparent onPress={() => this.setState({ showTopic: false })}>
    //                         <Icon style={{ color: "gray" }} size={30} name="ios-close" />
    //                     </Button>
    //                 </Left>
    //                 <Body style={{ flex: 1, alignItems: "center" }}>
    //                     <Title style={{ color: "#111" }}>{title}</Title>
    //                 </Body>
    //                 <Right style={{ flex: 1 }} >
    //                 </Right>
    //             </Header>
    //             <UnitView
    //                 data={data}
    //                 mode={2} // 0: study, 1: exam, 2: readonly
    //                 settings={settings}
    //             />
    //         </Modal>
    //     )
    // }

    resetScreen = internalAction => {
        this.lastResetDate = moment().toISOString();
        if (internalAction && _.isFunction(internalAction)) {
            internalAction();
        }
    };
}

export class WavingLineWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            volume: 0,
        };
    }

    componentDidMount() {
        SpeechRecognition.addEventListener("onVolumeChange", this._onVolumeChange);
    }

    componentWillUnmount() {
        SpeechRecognition.removeEventListener("onVolumeChange", this._onVolumeChange);
    }

    _onVolumeChange = event => {
        if (event.Volume && event.Volume !== this.state.volume) {
            this.setState({ volume: event.Volume });
        }
    };

    render() {
        return <WavingLine volume={this.state.volume} {...this.props} />;
    }
}

export default SpokenReadingResultView;
